const Datepicker = require('air-datepicker');
const debounce = require('throttle-debounce/debounce');
const templateNews = require('./news.ejs');
const platform = require('platform');

const lang = $("html").attr("lang");

if(lang !== "ru") {
	$.fn.datepicker.language['en'] = {
		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		daysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		today: 'Today',
		clear: 'Clear'
	};
}

class News {
	constructor(container) {
		this.container = container;
		this.containerFilterDatepicker = this.container.find('.js-news__datepicker');
		this.containerFilterSelect = this.container.find('.js-select--news');
		this.containerContent = this.container.find('.js-news-content');
		this.btnResetFilter = this.container.find('.js-news__reset');
	}

	getParams() {
		return {
			ajax: true,
			current: parseInt(this.container.attr('data-news-current')),
			type: this.containerFilterSelect.val(),
			date: this.containerFilterDatepicker.val(),
			lang: getLang(),
			header: this.containerContent
				.find('.js-news-header')
				.last()
				.text()
		};
	}

	initDatepicker() {
		this.containerFilterDatepicker
			.datepicker({
				language: lang,
				autoClose: true,
				onSelect: function (formattedDate, date, inst) {
					$(inst.el).trigger('change');
				}
			});
	}

	initSelect() {
		if (!(platform.name == 'IE' && parseInt(platform.version) < 11)) {
			this.containerFilterSelect
				.outerWidth('100%')
				.select2({
					theme: 'news-filter',
					minimumResultsForSearch: Infinity
				});
		}
	}

	resetFilter() {
		this.containerFilterDatepicker
			.datepicker()
			.data('datepicker')
			.clear();

		this.containerFilterSelect
			.val(function () {
				return $(this).find('option').eq(0).val();
			})
			.trigger('change');
	}

	checkActiveFilter() {
		let params = this.getParams();

		if (params.date || (params.type && params.type !== this.containerFilterSelect.find('option').eq(0).val())) {
			this.btnResetFilter
				.removeClass('disabled')
				.attr('disabled', false);
		} else {
			this.btnResetFilter
				.addClass('disabled')
				.attr('disabled', true);
		}
	}

	create() {
		this.initDatepicker();
		this.initSelect();

		this.container
			.find('.js-news__reset')
			.on('click', (e) => this.resetFilter(true));

		this.container
			.find('.js-news-loader')
			.on('click', (e) => {
				let current = parseInt(this.container.attr('data-news-current')),
					total = parseInt(this.container.attr('data-news-total'));

				if (current < total) {
					this.sendRequest();
				}
			});

		$('.js-select--news, .js-news__datepicker')
			.on('change', debounce(100, (e) => this.sendRequest(true)));


// белиберда для цвета датапикера ===>
		$('.js-news__datepicker').on('change', function () {
			let $this = $(this);
			let thisLabel = $this.closest('label');

			if ($this.val() == '') {
				thisLabel.addClass('empty');
			} else {
				thisLabel.removeClass('empty');
			}
		});
// <===
		
		this.checkScroll();
	}

	checkScroll() {
		let self = this;
		let positionPoint = $(window).scrollTop();
		let bottomPoint = $(document).height() - $(window).height() - $(document).find('.footer').outerHeight();

		if (positionPoint >= bottomPoint) {
			let current = parseInt(self.container.attr('data-news-current')),
				total = parseInt(self.container.attr('data-news-total'));

			if (current < total) {
				self.sendRequest();
			}
		}
	}

	sendRequest(firstLoad = false) {
		const dataAjaxPath = this.container.attr('data-ajax-path');
		const $preloader = '<div class="preloader"></div>';

		let params = this.getParams();
		let newsContainer = this.containerContent;
		let self = this;

		self.container
			.find('.js-news-loader')
			.hide();

		self.checkActiveFilter();

		if (firstLoad) {
			params.current = 1;
			params.header = '';

			newsContainer
				.html($preloader);

		} else {
			params.current++;
			newsContainer.append($preloader);
		}

		$.post(dataAjaxPath, params)
			.done(function (data) {
				newsContainer
					.find('.preloader')
					.remove();

				let json = JSON.parse(data);
				if (json.total > 0) {
					if (firstLoad) {
						// json.template = 'new';
						newsContainer
							.html(templateNews(json));

						self.container
							.attr('data-news-total', json.total)
							.attr('data-news-current', 1);
					} else {
						// if (params.header == Object.keys(json.dates)[0]) {
						// 	let cutJson = {};
						// 	cutJson.dates = {};
						// 	cutJson.dates[params.header] = json.dates[params.header];
						// 	cutJson.template = 'current_month';
						// 	newsContainer
						// 		.find('.news__content:last')
						// 		.append(templateNews(cutJson));
						// 	delete json.dates[params.header];
						// }

						// if (Object.keys(json.dates).length) {
						// 	json.template = 'new';
						// 	newsContainer
						// 		.append(templateNews(json));
						// }

						newsContainer
							.append(templateNews(json));

						self.container
							.attr('data-news-current', json.current);
					}
				} else {
					newsContainer
						.html('<p class="news__empty-result">Sorry, there are no results matching your filter criteria</p>');

					self.container
						.attr('data-news-total', 1)
						.attr('data-news-current', 1);
				}

				if (json.current < json.total) {
					self.container
						.find('.js-news-loader')
						.show();
				}
			})
			.fail(function (data) {
				newsContainer
					.find('.preloader')
					.remove();

				showNotyfications('ajax request failed', {
					type: 'error'
				});

				console.error('ajax request failed');
			});
	}
}

let news = new News($('.js-news'));
news.create();

$(document).on('touchmove scroll mousewheel DOMMouseScroll', debounce(100, function (e) {
	if (!$('.js-news-content').find('.preloader').length) {
		news.checkScroll(e);
	}
}));

// modal photos on detail news page
$('.news__img--small').colorbox({
	rel: 'news',
	onComplete: function () {
		$('#cboxPrevious').attr('title', 'Prev');
		$('#cboxNext').attr('title', 'Next');
		$('#cboxClose').attr('title', 'Close');
	}
});



// WEBPACK FOOTER //
// ./frontend/components/news/news.js